import React from "react";

const Map = () => {
  return (
    <div className="mb-5 pt-2">
      <iframe
        title="location map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3922.6273154930277!2d7.428290014285359!3d10.529991266574559!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104d352de84909f3%3A0x9a498e568ddcae4c!2s2M%20Seamless!5e0!3m2!1sen!2sng!4v1666869619743!5m2!1sen!2sng"
        width="100%"
        height="450"
        className="border-0 border-none"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Map;
